<template>
  <div class="content content-full">
    <div v-show="validating">
      <div id="sumsub-websdk-container"></div>
    </div>
    <div class="page-inner" v-show="!validating">
      <div class="pt-2 pb-2">
        <div class="">
          <h2 class="pb-0 bold-500 text-35 title-statements pr-3 h1">{{ $t('bank') }}</h2>
        </div>
      </div>
      <div v-if="!user.subscription">
        <div class="card card-dark bg-primary-gradient mb-4">
          <div class="card-header pb-1">
            <h3 class="mb-0" v-html="$t('maximize_royalties_title')">
            </h3>
          </div>
          <div class="card-body py-2" v-html="$t('maximize_royalties_description')">
          </div>
          <div class="card-footer text-right">
            <router-link to="/upgrade?from=statements" class="btn btn-gradient">
              {{ $t('upgrade_now') }}
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="alert alert-warning mt-2">
        {{ $t('statements_maintenance') }}
      </div> -->
      <div class="mt-2 pb-5 balance-info-container">
        <div class="row">
          <div class="col-md-4 mt-3">
            <div class="card-post mt-3">
              <div class="pos-relative">
                <div class="d-flex select-artist-container">
                  <div class="avatar mr-1"></div>
                  <div class="info-post ml-2">
                    <h4 class="h5 m-0">{{ $t('select_artist') }}</h4>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="avatar mr-1" v-if="currentStatementArtist && currentStatementArtist._id">
                    <img :src="currentStatementArtist.cover_image_small || currentStatementArtist.cover_image || '/static/img/img-placeholder.jpg'" onerror="this.src = '/static/img/img-placeholder.jpg'" alt="Current Artist" class="avatar-img rounded-circle">
                  </div>
                  <div class="avatar mr-1" v-if="!currentStatementArtist">
                    <img :src="user.profile_image || '/static/img/img-placeholder.jpg'" onerror="this.src = '/static/img/img-placeholder.jpg'" alt="Current Artist" class="avatar-img rounded-circle">
                  </div>
                  <div class="info-post ml-2">
                    <div class="username mt-1" v-if="loaded">
                      <div class="select2-input">
                        <Select2 :change="setCurrentArtist()" v-model="activeArtistId" :options="artistSelect"></Select2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 text-right balance-container" :class="pendingPayment() ? 'pt-5 mt-2' : ''">
            <!-- <span v-if="!(pendingPayment())"><b>{{ $t('available_balance') }}</b></span>
            <span v-else><b>{{ $t('payment_requested') }}</b></span> -->
            <span><b>{{ $t('available_balance') }}</b></span>
            <br>
            <span class="price-spam" :class="pendingPayment() ? 'text-muted' : '' ">
              ${{ user.hide_royalties || (currentStatementArtist && currentStatementArtist.hide_royalties) ? 0.00 : balance.toFixed(2) }}
            </span>
            <br>
            <button type="button" class="btn btn-primary price-button" v-show="!(pendingPayment())" :disabled="!balance || requested || requesting || loading" @click="showPrecalculationRequest()">
              <i class="fa fa-spinner fa-spin mr-2" v-if="requesting"></i>
              {{ $t('Withdrawal') }}
            </button>
          </div>
        </div>
      </div>
      <!-- <div v-if="!user.subscription" class="text-center mt-3 mb-3 p-3">
        <ins class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-8326584585992829"
          data-ad-slot="1941453159"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div> -->
      <div class="p-3 text-center mt-4 text-muted" v-if="loading">
        <i class="fa fa-spinner fa-spin mr-2"></i> {{ $t('loading_information') }}
      </div>
      <div class="mt-0" v-if="payouts.length && !loading && (!user.hide_royalties && (currentStatementArtist && !currentStatementArtist.hide_royalties))">
        <h3 ref="payoutsContainer"><b>{{ $t('payment_requests') }}</b></h3>
        <div class="card mt-3 table-responsive payments-container">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>{{ $t('amount') }}</th>
                <th>{{ $t('requested_date') }}</th>
                <th>{{ $t('estimated_payment_date') }}</th>
                <th>{{ $t('status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(payout, index) in payouts" v-bind:key="`payout_${index}`" v-show="payout.amount > 0 && !payout.description" :class="{'requested-paid': !payout.paid }">
                <td>
                  {{ currency.format(payout.amount) }}
                </td>
                <td>{{ moment.utc(payout.createdAt).format('LL') }}</td>
                <td>
                  <div v-if="!payout.paid && !payout.processing">
                    <span v-if="user.subscription">
                      {{
                        moment.utc(payout.createdAt).add(1, 'months').startOf('month').add(17, 'days').format('DD MMM') + ' - ' +
                        moment.utc(payout.createdAt).add(1, 'months').startOf('month').add(24, 'days').format('DD MMM')
                      }}
                    </span>
                    <span v-if="!user.subscription">
                      {{
                        moment.utc(payout.createdAt).add(3, 'months').startOf('month').add(17, 'days').format('DD MMM') + ' - ' +
                        moment.utc(payout.createdAt).add(3, 'months').startOf('month').add(24, 'days').format('DD MMM')
                      }}
                    </span>
                  </div>
                  <div v-if="!payout.paid && payout.processing">
                    {{ $t('processing_payout') }}
                  </div>
                </td>
                <td>
                  {{ payout.paid ? $t('paid') : $t('pending') }}
                  <span v-if="payout.paid"> -
                    <a :href="'/receipt/payout/'+payout._id" target="_blank">{{ $t('see_receipt') }}</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mt-4" v-if="!loading && statementPeriods.length">
        <div class="row">
          <div class="col-md-12" id="periods">
            <h3><b>{{ $t('periods') }}</b></h3>
            <div class="card card-primary p-3 mt-4 mb-4">
              <h5 class="mb-0">{{ $t('important') }}</h5>
              <p class="mb-0">{{ $t('some_reports_may_contain') }}</p>
            </div>

            <div class="card card-warning p-3 mt-2 mb-4" v-if="showNegativeExplainer">
              <h5 class="mb-0">{{ $t('why_negative') }}</h5>
              <p class="mb-0">
                {{ $t('negative_explainer') }}
              </p>
            </div>

            <div class="mt-3" v-for="(statement, index) in statementPeriods" v-bind:key="`royalties_${index}`" >
              <label>
                {{ moment.utc(statement.reportingPeriod).format('MMMM, YYYY') }}
              </label>
              <div class="card p-3 mt-1 mb-4 price-period-div">
                <span class="price-period-span" :title="statement.amount">${{ user.hide_royalties || (currentStatementArtist && currentStatementArtist.hide_royalties) ? 0.00 : statement.amount.toFixed(4) }} USD</span>
                <a class="dsp-text" @click="showDspDetails(statement.reportingPeriod)" href="javascript:void(0)" v-if="statement.source == 'indiefy'">
                  {{ $t('details') }}
                </a>
              </div>
            </div>
            <button class="card-header card p-3 mt-1 mb-4 adjustment-menu collapsed" data-toggle="collapse" data-target="#adujstmenContainer" aria-expanded="false" aria-controls="adujstmenContainer" v-if="adjustmentPeriods.length">
              {{ $t('adjustment') }}
              <div class="fas fa-angle-right icon"></div>
            </button>
            <div id="adujstmenContainer" data-parent="#periods" class="collapse">
              <div class="mt-3" v-for="(adjustment, index) in adjustmentPeriods" v-bind:key="`royaltiesAdjust_${index}`">
                <label>
                  {{ moment.utc(adjustment.date).format('MMMM, YYYY') }}
                </label>
                <div class="card p-3 mt-1 mb-4 price-period-div">
                  <span class="price-period-span pr-3" :title="adjustment.amount">${{ user.hide_royalties || (currentStatementArtist && currentStatementArtist.hide_royalties) ? 0.00 : adjustment.amount.toFixed(2) }} USD</span>
                  <span class="description" v-if="adjustment.description"><i>{{ adjustment.description }}</i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 text-center" v-if="!loading && !statementPeriods.length">
        <a class="title-statements-why" target="_blank" href="https://help.indiefy.net/hc/en-us/articles/360046376653-When-do-I-get-paid-for-my-music-">{{ ((lang === 'es') ? 'No veo mis reportes, ¿por qué?' : 'I don’t see my reports, Why?') }}</a>
      </div>
    </div>

    <div class="m-4 p-4"></div>

    <div ref="modalPro" class="modal dark-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center">
        <div class="modal-content">
          <div class="modal-body">
            <div class="mt-4 mb-4" style="font-size:16px;font-weight:200;">Indiefy <b>PRO</b></div>
            <div style="max-width: 160px; height: 160px; margin: 0 auto; border-radius: 50%; background: url(/static/img/image1.webp);background-size: 250%;position: relative;background-position: 57% 30%;">
              <img src="/static/img/money-with-wings_1f4b8.png" alt="" style="height: 80px; width: 80px; position: absolute; left: 50%; margin-left: -40px; top: 50%; margin-top: -40px;"/>
            </div>
            <div class="mt-4">
              <b>{{ $t('quick_withdrawal') }}</b><br>
              <span style="font-size: 13px; font-weight: 200;">{{ $t('withdrawal_instead') }}</span>
            </div>
            <br>
            <div class="container-buttons mt-2">
              <router-link to="/upgrade?from=statements" >
                <button class="btn btn-gradient">{{ $t('upgrade_now') }} <i class="fa fa-rocket ml-1"></i></button>
              </router-link>
              <br><br>
              <button class="btn btn-maybe" data-dismiss="modal">{{ $t('maybe_later') }}</button>
            </div>
            <br>
            <div class="text-footer mb-4" style="font-weight: 200;">
              {{ $t('suscriptions_renew_modal') }}
              <a style="font-weight: normal;" href=" https://help.indiefy.net/hc/en-us/articles/360046365893-How-can-I-cancel-my-PRO-subscription-">{{ $t('learn_more') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="modalPaypal" class="modal light-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center">
        <div class="modal-content">
          <div class="modal-body">
            <div class="pt-4 pb-4 title" style="">{{ $t('add_paypal_account') }}</div>
            <br><br>
            <div class="mt-4 description">
              <span>{{ $t('need_paypal_account') }}</span>
            </div>
            <div class="mt-4 button-container">
              <button class="btn mr-4 btn-default btn-border" data-dismiss="modal">{{ $t('cancel') }}</button>
              <button class="btn btn-primary" @click="navigatePaypalArtist()">{{ $t('add_paypal') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="modalSelectPayment" class="modal light-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" v-if="currentStatementArtist">
      <div class="modal-dialog modal-center">
        <div class="modal-content">
          <div class="modal-body">
            <div class="pt-4 pb-4 title" style="">{{ $t('confirm_payment_method') }}</div>
            <div class="mt-4 description row">
              <div class="col-lg-12 border rounded option-wise mb-1 p-0 text-left" :class="currentStatementArtist.payment_method !== 'stripe' ? 'selected' : ''">
                <div class="custom-control custom-radio m-0 pr-0 pl-0 w-100">
                  <input type="radio" value="wise" name="paymentMethod" v-model="currentStatementArtist.payment_method" class="custom-control-input" id="wise">
                  <label class="custom-control-label w-100 pl-4 pr-5 pointer" for="wise">
                    <img src="https://wise.com/public-resources/assets/logos/wise/brand_logo.svg">
                    <small class="form-text text-muted p-0 m-0 pb-2 pt-2"
                      v-if="(currentStatementArtist.payment_method === 'wise') && (user.stripe_completed && user.payments_details)">
                      <i>{{ $t('current_payment_method') }}</i>
                    </small>
                  </label>
                </div>
              </div>
              <div class="col-lg-12 border rounded option-stripe mb-1 p-0 text-left" :class="currentStatementArtist.payment_method !== 'wise' ? 'selected' : ''">
                <div class="custom-control custom-radio m-0 pr-0 pl-0 w-100">
                  <input type="radio" value="stripe" name="paymentMethod" v-model="currentStatementArtist.payment_method" class="custom-control-input" id="stripe">
                  <label class="custom-control-label w-100 pl-4 pr-5 pointer" for="stripe">
                    <img src="/static/img/stripe-logo.png" alt="logo-stripe" class="logo-stripe">
                    <small class="form-text text-muted p-0 m-0 pb-2"
                      v-if="(currentStatementArtist.payment_method === 'stripe') && (user.stripe_completed && user.payments_details)">
                      <i>{{ $t('current_payment_method') }}</i>
                    </small>
                  </label>
                </div>
              </div>
            </div>
            <div class="mt-4 button-container">
              <button class="btn mr-4 btn-default btn-border" data-dismiss="modal" :disabled="requesting">
                {{ $t('cancel') }}
              </button>
              <button class="btn btn-primary" @click="setPaymentMethod(true)" :disabled="requesting">
                {{ $t('continue') }}
                <span v-if="requesting">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="modalStripePayment" class="modal stripe-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <img src="/static/img/stripe-background.jpg" alt="stripe-background" class="stripe-background">
              </div>
              <div class="col-lg-4">
                <div class="stripe-title">{{ $t('stripe_title') }}</div>
              </div>
              <div class="col-lg-8">
                <div class="col-lg-12 stripe-description">{{ $t('stripe_description') }}</div>
                <div class="col-lg-12 text-right stripe-buttons">
                  <button class="btn mr-2 btn-default btn-border" data-dismiss="modal" @click="hideModalStripe()">{{ $t('cancel') }}</button>
                  <router-link to="/account?royalties=1" class="btn btn-primary">
                    {{ $t('stripe_set_up') }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="modalPrecalculation" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title fw-bold text-white">
              {{ $t('upgrade_maximize_royalties') }}
            </h5>
            <button type="button" class="close small" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times text-white"></i>
            </button>
          </div>
          <div class="modal-body">
            <div>
              {{ $t('basic_costs_explanation') }}
            </div>
            <div class="row mt-4">
              <div class="col-6 text-center">
                {{ $t('basic_balance') }}<br/>
                <h3>${{ (balance || 0).toFixed(2) }} USD</h3>
              </div>
              <div class="col-6 text-center">
                {{ $t('pro_balance') }}<br/>
                <h2>${{ (proBalance || 0).toFixed(2) }} USD</h2>
              </div>
            </div>
          </div>
          <div class="div p-2">
            <button type="button" class="btn btn-block d-block" data-dismiss="modal" @click="openModalMethodPayment()">
              {{ $t('continue_as_basic') }}
            </button>
            <router-link to="/upgrade?from=statements-probalance" class="btn btn-primary btn-block fw-bold">
              {{ $t('withdraw') }}: ${{ (proBalance || 0).toFixed(2) }} USD
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div ref="modalDspDetails" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" v-if="dspReportDetails && dspReportDetails.length">
              {{ moment().year(dspReportDetails[0].year).month(dspReportDetails[0].month - 1).format('MMMM, YYYY') }}
            </h5>
            <button type="button" class="close small text-muted" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body p-0">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>{{ $t('song') }}</th>
                  <th>{{ $t('platform') }}</th>
                  <th>{{ $t('royalties') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(statement, index) in dspReportDetails" v-bind:key="`dsp_${index}`">
                  <td>
                    {{ statement.asset_title || statement.product_title || 'N/A' }}
                  </td>
                  <td>
                    {{ statement.dsp || 'N/A' }}
                  </td>
                  <td>
                    ${{ statement.amount.toFixed(4) }} USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import User from '../services/user'
import Artist from '../services/artists'
import moment from 'moment'
import router from '../router/index'
import countries from '../data/countries'
import Select2 from './utils/Select2'
import Filters from '../components/utils/filters'
import snsWebSdk from '@sumsub/websdk'

export default {
  name: 'Account',
  data () {
    return {
      showNegativeExplainer: false,
      loaded: false,
      icons: {
        'Spotify': 'spotify.png',
        'Google Play': 'googleplay.png',
        'YouTube Music': 'youtube.png',
        'Facebook Audio Library': 'facebook.png',
        'YouTube Content ID': 'content-id.png',
        'Beatport': 'beatport.png',
        'iTunes/Apple Music': 'apple.png',
        'Apple Music': 'apple.png'
      },
      validating: false,
      requested: false,
      requesting: false,
      user: {},
      balance: 0,
      minBalance: 100,
      proBalance: 0,
      moment: moment,
      currentArtist: null,
      currentStatementArtist: null,
      artists: [],
      statementArtists: [],
      payouts: [],
      currentReport: {},
      paid: 0,
      lang: '',
      statements: [],
      originalStatements: [],
      periods: [{id: 0, name: 'All'}],
      loading: false,
      router: router,
      insights: {
        artist: [],
        country: [],
        release: [],
        store: [],
        track: []
      },
      countries,
      artistSelect: [],
      activeArtistId: null,
      currency: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }),
      dspReportDetails: []
    }
  },
  computed: {
    statementPeriods: function () {
      return _.filter(this.statements, item => item.balanceTypeName === 'Statement')
    },
    adjustmentPeriods: function () {
      return _.filter(this.statements, item => item.balanceTypeName === 'Adjustment')
    }
  },
  methods: {
    saveRequest: function (artistId) {
      User.requestPayment(artistId).then(() => {
        this.requesting = false
        this.requested = true
        this.getPayouts().then(() => {
          window.$(this.$refs.modalSelectPayment).modal('hide')
          this.$notify({ message: this.$t('payment_request_sent') }, 'success', 'fa-check')
        })
      }).catch((response) => {
        this.requesting = false
        this.requested = false
        this.$notify({ message: this.$t('error_request_payment') }, 'warning', 'fa-exclamation')
        console.error('Error when requesting payment', response)
      })
    },
    showPrecalculationRequest: function () {
      // TODO: Just validate if proBalance is greater than balance in 2024
      if (this.user.subscription || ((this.proBalance - this.balance) < 10)) {
        this.openModalMethodPayment()
      } else {
        window.$(this.$refs.modalPrecalculation).modal('show')
      }
    },
    getNewAccessToken: function () {
      return new Promise((resolve, reject) => {
        User.createVerificationToken().then(response => {
          resolve(response.data.token)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    launchWebSdk (accessToken) {
      this.validating = true

      let snsWebSdkInstance = snsWebSdk.init(accessToken, () => this.getNewAccessToken())
        .withConf({
          lang: this.$i18n.locale,
          email: this.user.email
        })
        .on('onError', (error) => {
          console.log('onError', error)
        })
        .onMessage((type, payload) => {
          // console.log('onMessage', type, payload, payload.reviewResult)

          if (type === 'idCheck.onApplicantLoaded') {
            this.user.applicant_id = payload.applicantId
          }

          if ((type === 'idCheck.applicantStatus' || type === 'idCheck.onApplicantStatusChanged') && payload.reviewResult && payload.reviewResult.reviewAnswer === 'GREEN') {
            setTimeout(() => {
              User.update({ identity_verified: 1, applicant_id: this.user.applicant_id }, () => {})
              this.user.identity_verified = 1
              this.validating = false
              this.openModalMethodPayment()
              this.$forceUpdate()
            }, 1000)
          } else if (this.user.applicant_id) {
            User.update({ applicant_id: this.user.applicant_id }, () => {})
          }
        })
        .build()

      snsWebSdkInstance.launch('#sumsub-websdk-container')
    },
    showDspDetails: function (reportingPeriod) {
      this.dspReportDetails = _.filter(this.originalStatements, item => item.reportingPeriod === reportingPeriod)

      window.$(this.$refs.modalDspDetails).modal('show')
    },
    pendingPayment: function () {
      let pending = false

      _.each(this.payouts, item => {
        if (!item.paid) {
          pending = true
        }
      })

      return pending
    },
    getPayouts: function () {
      let artistId = ''

      if (this.currentStatementArtist) {
        artistId = this.currentStatementArtist._id
      }

      if (!artistId) {
        artistId = 'collab'
      }

      return User.getPayouts(artistId).then(response => {
        let totalRoyalties = 0
        this.loading = false
        this.payouts = response.data
        this.totalPaid = 0
        this.proBalance = 0

        this.payouts.sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt)
        })

        this.requested = false

        _.each(response.data, elem => {
          if (!elem.paid) {
            this.requested = true
          }
          this.totalPaid += elem.amount
        })

        _.each(this.statements, (item, idx) => {
          if (item.balanceTypeName === 'Statement' || item.balanceTypeName === 'Adjustment') {
            this.proBalance += item.pro_amount
            totalRoyalties += item.amount
          }
        })

        this.balance = totalRoyalties - this.totalPaid
        this.proBalance = this.proBalance - this.totalPaid

        if (this.balance < 0) {
          this.balance = 0
        } else {
          if (this.balance >= 50 && !this.user.stripe_completed && !this.user.payoneer_account) {
            setTimeout(() => {
              window.$(this.$refs.modalStripePayment).modal('show')
            }, 10)
          }
        }
      })
    },
    openModalMethodPayment: function () {
      let hasPaymentDefault = false

      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }

      if (!this.user.stripe_completed && !this.user.payoneer_account) {
        return window.$(this.$refs.modalStripePayment).modal('show')
      }

      if (!this.currentStatementArtist) {
        return this.requestPayment(true)
      }

      if (this.user.payments_details && (this.user.stripe_id && this.user.stripe_completed) && this.currentStatementArtist.payment_method !== 'payoneer' && this.currentStatementArtist.payment_method !== 'sendValu') {
        window.$(this.$refs.modalSelectPayment).modal('show')
      } else {
        if (this.currentStatementArtist.payment_method) { // has default payment_method
          switch (this.currentStatementArtist.payment_method) {
            case 'stripe':
              if (this.user.stripe_id && this.user.stripe_completed) {
                hasPaymentDefault = true
              }
              break
            case 'wise':
              if (this.user.payments_details) {
                hasPaymentDefault = true
              }
              break
            case 'payoneer':
              if (this.user.payoneer_account) {
                hasPaymentDefault = true
              }
              break
            case 'sendValu':
              if (this.user.payments_details) {
                hasPaymentDefault = true
              }
              break
          }

          if (hasPaymentDefault) {
            this.requestPayment(true)
          } else {
            // error payment method unknown
            return this.$notify({ message: this.$t('unknown_payment_method') }, 'warning', 'fa-exclamation')
          }
        } else {
          if (this.user.payments_details) {
            this.currentStatementArtist.payment_method = 'wise'
          } else if (this.user.stripe_id && this.user.stripe_completed) {
            this.currentStatementArtist.payment_method = 'stripe'
          } else if (this.user.payoneer_account) {
            this.currentStatementArtist.payment_method = 'payoneer'
          } else {
            // load stripe modal
            return window.$(this.$refs.modalStripePayment).modal('show')
          }
          if (_.contains(['wise', 'stripe', 'payoneer'], this.currentStatementArtist.payment_method)) {
            this.setPaymentMethod(true)
          }
        }
      }
    },
    setPaymentMethod: function (passPro = false) {
      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }
      Artist.setPaymentMethod(this.currentStatementArtist._id, this.currentStatementArtist.payment_method).then(response => {
        window.$(this.$refs.modalSelectPayment).modal('hide')
        this.requestPayment(passPro)
      }, () => {
        this.$notify({ message: this.$t('error_set_payment_method') }, 'warning', 'fa-exclamation')
      })
    },
    requestPayment (passPro = false) {
      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }

      let artistId = 0

      if (this.requesting) return

      if (this.user.hide_royalties || (this.currentStatementArtist && this.currentStatementArtist.hide_royalties)) {
        return this.$notify({ message: this.$t('suspicious_activity_contact') }, 'warning', 'fa-exclamation')
      }

      if (_.find(this.payouts, item => !item.paid)) {
        if (this.pendingPayment()) {
          return this.$notify({ message: this.$t('already_sent_payment_request') }, 'warning', 'fa-exclamation')
        }
      }

      if (this.balance >= this.minBalance) {
        if (!this.user.identity_verified) {
          return this.requestVerification()
        }

        this.requesting = true

        if (!this.currentStatementArtist) {
          artistId = 'collab'
        } else {
          if (!this.currentStatementArtist && this.artists && this.artists[0]) {
            artistId = this.artists[0]._id
          } else {
            artistId = this.currentStatementArtist._id
          }
        }

        if (!this.user.subscription && this.balance > 100) {
          return window.swal({
            title: this.$t('request_limit_basic_title'),
            text: this.$t('request_limit_basic'),
            buttons: {
              cancel: {
                visible: true,
                text: this.$t('continue'),
                className: 'btn btn-default btn-border no-border'
              },
              confirm: {
                text: this.$t('upgrade_now'),
                className: 'btn btn-primary'
              }
            }
          }).then((confirm) => {
            if (confirm) {
              this.$router.push('/upgrade?from=statements')
            } else {
              this.saveRequest(artistId)
            }
          })
        } else {
          this.saveRequest(artistId)
        }
      } else {
        if (this.user.subscription) {
          return this.$notify({ message: this.$t('minimum_payment_is_pro') }, 'warning', 'fa-exclamation')
        } else {
          if (passPro) {
            return window.$(this.$refs.modalPro).modal('show')
          }
        }
      }
    },
    showReportDetails: function (report) {
      this.details = []
      this.currentReport = report

      User.getMonthDetails(this.currentArtist, report.report_year, report.report_month).then(response => {
        this.details = response.data
        this.$forceUpdate()
      })
    },
    setCurrentArtist: function () {
      if (this.currentStatementArtist && this.activeArtistId) {
        if (this.currentStatementArtist._id !== this.activeArtistId) {
          this.currentStatementArtist = _.find(this.statementArtists, artist => {
            return artist._id === this.activeArtistId
          })

          this.getRoyalties()
        }
      }
    },
    getRoyalties: function () {
      let artistId = ''
      this.balance = 0
      this.loading = true
      this.statements = []
      this.insights = {
        artist: [],
        country: [],
        release: [],
        store: [],
        track: []
      }
      this.payouts = []

      if (this.user.hide_royalties || (this.currentStatementArtist && this.currentStatementArtist.hide_royalties)) {
        setTimeout(() => {
          this.loading = false
        }, 2000)

        return false
      }

      if (this.currentStatementArtist && this.currentStatementArtist._id) {
        artistId = this.currentStatementArtist._id
      } else {
        artistId = 'collab'
      }

      User.getBalance(artistId).then(response => {
        this.statements = response.data
        this.originalStatements = _.clone(response.data)

        this.statements.sort(function (a, b) {
          return new Date(b.reportingPeriod) - new Date(a.reportingPeriod)
        })

        let groupedReports = {}

        _.each(this.statements, item => {
          if (!groupedReports[item.reportingPeriod]) {
            groupedReports[item.reportingPeriod] = _.clone(item)
          } else {
            groupedReports[item.reportingPeriod].amount += item.amount
            groupedReports[item.reportingPeriod].pro_amount += item.pro_amount
          }
        })

        this.statements = _.toArray(groupedReports)

        if (_.find(this.statements, item => item.amount < 0)) {
          this.showNegativeExplainer = true
        }

        this.$forceUpdate()

        this.getPayouts().then(() => {
          window.$('.toggle-checkbox[data-toggle]').bootstrapToggle()
          this.$forceUpdate()
        })
      })
    },
    navigatePaypalArtist: function () {
      if (this.requesting) return
      this.router.push({path: `/artists/${this.currentStatementArtist.key}`, query: { hasFocusPaypal: '1' }})
    },
    requestVerification: function () {
      User.createVerificationToken().then(response => {
        this.launchWebSdk(response.data.token)
      }).catch(error => {
        console.log('Error when requesting token', error)
      })
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale

    if (this.user.subscription) {
      this.minBalance = 50
    } else if (this.user.min_balance) {
      this.minBalance = this.user.min_balance
    }

    Artist.getAllRoyalities().then(response => {
      this.statementArtists = response.data

      if (this.$route.query.artist) {
        this.currentStatementArtist = _.find(this.statementArtists, item => item._id === this.$route.query.artist)
        this.activeArtistId = this.$route.query.artist
      }

      if (!this.currentStatementArtist) {
        this.currentStatementArtist = this.statementArtists[0]
        this.activeArtistId = this.statementArtists[0]._id
      }

      this.artistSelect = [{ id: 'collab', text: 'Colaborative Royalties' }].concat(_.map(this.statementArtists, (artist, idx) => {
        let node = { id: artist._id, text: artist.name }
        return node
      }))

      this.loaded = true
      this.getRoyalties()
    })
  },
  mounted: function () {
    let dateValidate = new Date()
    if (moment(dateValidate).isBetween('2021-04-20', '2021-05-04')) {
      setTimeout(() => {
        let html = document.createElement('div')
        html.innerHTML = '<i class="fas fa-exclamation-triangle text-warning pb-4 pt-3"></i><br>' + '<div class="pr-4 pl-4 pb-3">' + this.$t('due_maintenance_balance') + '</div>'
        window.swal({
          title: this.$t('under_maintenance'),
          content: html,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: this.$t('i_understand'),
              className: 'btn btn-primary'
            }
          }
        })
      }, 500)
    }

    if (window.$('html').hasClass('topbar_open')) { // if mobile menu is open, close it
      window.$('.topbar-toggler').click()
    }

    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 100)
    // }
  },
  components: {
    Select2
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.price-period-div a.dsp-text {
  margin-top: 3px;
  font-size: 14px;
}

.info-post {
  width: 81%;
  display: block;
}

.balance {
  font-weight: 800;
  font-size: 48px;
}

.pointer {
  cursor: pointer;

  &:hover td {
    background-color: #d9efff;
  }
}

.card-primary {
  background-color: #A581FF !important;
}
.price-spam {
  font-weight: bold;
  font-size: 48px;
  line-height: 65px;
}
.price-button {
  float: right;
  margin-top: 10px;
}
.date-span {
  color: #808080
}
.price-period-div{
  border-radius: 5px;
  box-shadow: 0px 0px 5px 1px rgba(208, 208, 208, 0.6);
  display: block;
  padding: 15px 20px !important;
  a {
    color: #808080;
    float: right;
    font-size: 20px;
  }
  .price-period-span{
    font-size: 18px;
    font-weight: 500;
  }
  .price-period-status{
    float: right;
    padding-right: 20px;
    margin-top: 4px;
    font-weight: 500;
  }
  .pending-status {
    color: #5714ff;
  }
  .paid-status {
    color: #31ce36;
  }
}
.title-statements {
  display: inline-block;
}

.title-statements-why {
  text-decoration: underline;
  vertical-align: text-bottom;
  font-size: 12px;
}

.block-mobile{
  display: block;
}

.change-artist-container {
  position: absolute;
  top: 0;
  right: 0;
}

.artist-select {
  height: 38px !important;
}

.payments-container {
  overflow-x: visible;
  max-height: 30vh;
  overflow-y: auto;
}
.select-artist-container .avatar {
  height: 2rem;
}
.balance-info-container {
  padding-left: 20px;
}
.export-label {
  vertical-align: middle;
  height: 26px;
  display: inline-block;
}
.stripe-modal {
  .modal-dialog {
    max-width: 740px;
    .modal-body {
      padding: 0;
      .stripe-background {
        max-width: 740px;
        width: 100%;
        border-top-left-radius: 0.4rem !important;
        border-top-right-radius: 0.4rem
      }
      .stripe-title {
        font-size: 22px;
        font-weight: 700;
        padding: 38px 40px;
      }
      .stripe-description {
        padding: 38px 40px 38px 0;
      }
    }
  }
}
.logo-paypal {
  width: 85px;
}
.logo-stripe {
  width: 85px;
}
.custom-control-label {
  padding-top: 15px;
  text-decoration: none !important;
}
.option-wise .custom-control-label {
  padding-top: 20px;
}
.custom-control-label::before, .custom-control-label::after {
  left: initial;
  right: 2rem;
  top: 1.5rem;
}
.custom-radio .custom-control-input:checked~.custom-control-label::before {
  background-color: #5714ff;
}
.option-stripe .custom-control-label::before, .option-stripe .custom-control-label::after {
  top: 1.5rem;
}
.option-stripe, .option-wise {
  cursor: pointer;
  transition: all ease 0.3s;
}

.option-wise, .option-stripe{
  min-height: 65px;
}

.requested-paid {
  background: #ebe3ff;
}

.stripe-buttons {
  padding-bottom: 15px;
}

.adjustment-menu {
  width: 100%;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 1px rgba(208, 208, 208, 0.6);
  display: block;
  padding: 15px 20px !important;
  cursor: pointer;
  .icon {
    transition: all ease 0.2s;
    transform: rotate(90deg)
  }
  &.collapsed {
    .icon {
      transform: rotate(0deg)
    }
  }
}

@media only screen and (max-width: 992px) {
  .stripe-modal .modal-dialog .modal-body .stripe-description {
    padding: 38px 40px;
  }
  .stripe-modal .modal-dialog .modal-body .stripe-buttons {
    padding: 25px 40px;
  }
}

@media only screen and (max-width: 768px)  {
  .balance-container {
    text-align: center !important;
    margin-top: 50px;
  }
  .price-button {
    float: none;
  }
  .balance-info-container {
    padding-left: 0px !important;
  }
}

@media screen and (max-width:576px) {
  .modal-center {
    position: fixed;
  }
  .dark-modal .text-footer {
    padding: 0 20px;
  }
  .dark-modal .modal-body {
    overflow: scroll;
    max-height: 530px;
  }
  .light-modal .button-container button {
    display: inline-block;
    width: 40%;
    min-width: auto;
    margin: 0 !important;
    font-size: 11px;
  }
  .payments-container {
    overflow-x: auto !important;
    th {
      text-align: center;
    }
  }
  .stripe-modal .modal-dialog .modal-body .stripe-title {
    padding: 18px 40px;
  }
  .stripe-modal .modal-dialog .modal-body .stripe-description {
    padding: 18px 40px;
  }
  .stripe-modal .modal-dialog .modal-body .stripe-buttons {
    text-align: center !important;
  }
}

@media screen and (max-width: 400px) {
  .stripe-modal .modal-dialog .modal-body .stripe-title {
    text-align: center;
  }
  .stripe-modal .modal-dialog .modal-body .stripe-description {
    text-align: justify;
  }
  .stripe-modal .modal-dialog .modal-body .stripe-buttons {
    padding: 15px;
  }
}

@media screen and (max-width: 320px) {
  .stripe-modal .modal-dialog .modal-body .stripe-buttons .btn {
    max-width: 140px;
    margin-bottom: 50px;
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statements.vue